import type { ShippingOptionProps } from './ShippingOptionCard';
import { ShippingOptionCard } from './ShippingOptionCard';

export function SameDayDeliveryShippingOptionCard(props: ShippingOptionProps) {
  return (
    <ShippingOptionCard
      {...props}
      selected={props.field.value === props.name}
      onClick={() => props.field.onChange(props.name)}
      hasError={!!props.fieldState.error}
    />
  );
}
